import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router";
import { useAppKit } from "@reown/appkit/react";
import { checkLogin } from "@/lib/auth";
import { showInfo } from "@/lib/toast";
import type { RouteMeta } from "./routes";

export function AuthGuard({
  meta,
  children,
}: {
  meta: RouteMeta;
  children: ReactNode;
}) {
  const { open } = useAppKit();
  const [checked, setChecked] = useState(false);
  const needAuth = meta.requiresAuth && !checkLogin();

  useEffect(() => {
    if (needAuth) {
      open();
      showInfo("请先连接钱包");
    }
    setChecked(true);
  }, [needAuth, open]);

  if (!checked) return null;
  if (needAuth) return <Navigate to="/" replace />;
  return <>{children}</>;
}
